import React, { forwardRef, ReactNode } from "react";
import { Form } from "react-bootstrap";
import FieldError from "../components/FieldError";
import { IDefaultInput } from "../interfaces/default.interface";
import "./styles.css";
import "../styles.css";
import { handleChange } from "../functions/handleChange";
import { handleBlur } from "../functions/handleBlur";
import { formatValue } from "../functions/formatValue";
import LLabel from "../LLabel";

interface LFieldProps extends IDefaultInput {
  type?: string;
  value?: string | number;
  placeholder?: string;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  extraComponent?: ReactNode;
  min?: number;
  maxLength?: number;
  decimals?: number;
  isNumberField?: boolean;
  isValid?: boolean;
  classNameInput?: string;
}

// Alterado para `forwardRef`
const LField = forwardRef<HTMLInputElement, LFieldProps>(
  (
    {
      label,
      id,
      name,
      type = "text",
      value = "",
      placeholder = "",
      min,
      maxLength,
      onChange,
      onBlur,
      onKeyDown,
      isInvalid = false,
      required = false,
      className = "",
      classNameInput = "",
      style = {},
      disabled = false,
      error = null,
      size = "md",
      extraComponent,
      decimals = 2,
      isNumberField = false,
      isValid
    },
    ref, // Aqui está a ref sendo recebida
  ) => {
    return (
      <div className={`form-group w-100 ${className}`} style={style}>
        {label && <LLabel label={label} required={required} />}
        <div className="d-flex gap-2 extra-document">
          <Form.Control
            ref={ref} // Passando a ref para o input
            id={id}
            type={type}
            name={name ?? id ?? ""}
            min={min}
            maxLength={maxLength}
            value={isNumberField ? formatValue(value, decimals) : value}
            placeholder={placeholder}
            

            onChange={(e) => {
              if (isNumberField) {
                handleChange(e, onChange);
              } else if (onChange) {
                onChange(e);
              }
            }}
            onBlur={(e) => {
              if (isNumberField) {
                handleBlur(e, value, decimals, onChange);
              }
              if (onBlur) {
                onBlur(e);
              }
            }}
            onKeyDown={onKeyDown}
            disabled={disabled}
            className={`form-control form-control-${size} ${classNameInput} ${
              isInvalid ? "is-invalid" : ""
            } ${ isValid ? "is-valid" : ""}
            `}
          />
          {extraComponent}
        </div>
        {isInvalid && error && <FieldError text={error} />}
      </div>
    );
  },
);

LField.displayName = "LField";

export default LField;
